import React from 'react';
import { MessageSquareQuoteIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-200" data-mp="3kr5tk627v5kr">
      <div className="mx-auto max-w-5xl" data-id="element-201" data-mp="3fym68hdq8w2r">
        <h2 className="text-center font-serif text-[1.75rem] font-black leading-tight tracking-tight text-stone-900 sm:text-4xl" data-id="element-202" data-mp="3fxksu698nxhv">
          Lo Que Dicen los Docentes
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-stone-700" data-id="element-203" data-mp="370k94cx46nkr">
          <span aria-hidden="true" data-id="element-204" data-mp="31yuwisu8u1uk">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +1.500 Docentes
        </p>

        {testimonials.length > 0 ? <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-2" data-id="element-205" data-mp="2x11so6gexjxg">
            {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-stone-100 p-6" data-id="element-206" data-mp="2s431nws1pt3h">
                <div className="text-sm text-amber-500" aria-label="5 de 5 estrellas" data-id="element-207" data-mp="qbeuxdg70niy">
                  <span aria-hidden="true" data-id="element-208" data-mp="h8181pbqwil0">★ ★ ★ ★ ★</span>
                </div>
                <blockquote className="mt-4 flex-1 font-serif text-sm italic leading-relaxed text-stone-800" data-id="element-209" data-mp="m6m7hmj6ay8e">
                  &ldquo;{item.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-6" data-id="element-210" data-mp="c7mwhxaxqqi8">
                  <p className="text-xs font-bold text-stone-900" data-id="element-211" data-mp="zwfx472i5mj6">{item.name}</p>
                  <p className="text-xs text-stone-500" data-id="element-212" data-mp="zyiwhhpjos0k">{item.location}</p>
                </figcaption>
              </figure>)}
          </div> : <div className="mx-auto mt-10 flex max-w-2xl flex-col items-center rounded-2xl border-2 border-dashed border-stone-300 bg-stone-50 px-6 py-12 text-center" data-id="element-213" data-mp="q5v18re7qw3y">
            <MessageSquareQuoteIcon className="h-7 w-7 text-stone-400" aria-hidden="true" data-id="element-214" data-mp="1ivk0p0b9yo3g" />
            <p className="mt-3 text-sm font-semibold text-stone-600" data-id="element-215" data-mp="1nmses9njuxmy">
              [Colocar aquí testimonios reales de INGLÉS LISTO™]
            </p>
          </div>}
      </div>
    </section>;
}